// import { useRoutes } from 'react-router-dom';

// import { lazy, Suspense, useState } from 'react'; 

// // layouts
// import DashboardLayout from './layouts/dashboard';
// import S3BrowserComponent from './components/CMDBBackups/S3BrowserComponent';
// import ISPBad from './components/ISPManagementTable/ISPManagementDashboard/ISPBad';
// // import ISPBad1 from './components/ISPManagementTable/ISPManagementDashboard/ISPBad1/ISPBad1';
// import ISPDown from './components/ISPManagementTable/ISPManagementDashboard/ISPDown';
// import ISPDown1 from './components/ISPManagementTable/ISPManagementDashboard/ISPDown1/ISPDown1';
// import ISPGood from './components/ISPManagementTable/ISPManagementDashboard/ISPGood';
// // import ISPGood1 from './components/ISPManagementTable/ISPManagementDashboard/ISPGood1/ISPGood1';
// import SidewiseBad from './components/SidewiseComponents/Components/SidewiseBad';
// import SidewiseDown from './components/SidewiseComponents/Components/SidewiseDown';
// import SidewiseGood from './components/SidewiseComponents/Components/SidewiseGood';
// import SidewiseTotalLinks from './components/SidewiseComponents/Components/SidewiseTotalLinks';
// import ConfigBackupTableComponent from './components/CMDBBackups/ConfigBackupTableComponent';
// import BackupFail from './components/SummaryComponents/Components/CardStatus/BackupFail/BackupFail';
// import BackupSuccess from './components/SummaryComponents/Components/CardStatus/BackupSuccess/BackupSuccess';
// import Alerts from './pages/Alerts';
// import ConfigBackupEvents from './pages/ConfigBackupEvents';
// import Configuration from './pages/Configuration';
// import Credential from './pages/Credential';
// import Dashboard from './pages/Dashboard';
// import Dcagent from './pages/Dcagent';
// import EmailConfig from './pages/EmailConfig';
// import Endpoint from './pages/Endpoint';
// import Global from './pages/Global';
// import Inventory from './pages/Inventory';
// import Ipam from './pages/Ipam';
// import Locations from './pages/Locations';
// import Members from './pages/Members';
// import Network from './pages/Network';
// import OnDemand from './pages/OnDemand';
// import Overview from './pages/Overview';
// import Roles from './pages/Roles';
// import Schedulers from './pages/Schedulers';
// import Sdvan from './pages/Sdvan';
// import Sidewise from './pages/Sidewise';
// import Sitewise from './pages/Sitewise';
// import Smtp from './pages/Smtp';
// import Summary from './pages/Summary';
// import UnknownDevices from './pages/UnknownDevices';
// import Zones from './pages/Zones';
// import GroupedSummary from './pages/GroupedSummary';
// import DevicewiseSummary from './pages/DevicewiseSummary';
// import Health from './pages/Health';
// import OrganisationInfra from './pages/OrganisationInfra';
// import InfoTechserviceManagement from './pages/InfoTechserviceManagement';

// // Login-Logout
// import PageNotFound from './components/PageNotFound';
// import ForgotPassword from './layouts/ForgotPassword';
// import Login from './layouts/Login';
// import LogoOnlyLayout from './layouts/LogoOnlyLayout';
// import ResetPassword from './layouts/ResetPassword';
// import Settings from './layouts/Settings';
// import DeviceDown from './pages/DeviceDown';
// import DeviceUp from './pages/DeviceUp';
// import ConfigChangeBackupTable from './pages/ConfigBackupsTable';
// import General from './pages/General';
// import IgnoreRule from './pages/IgnoreRule'
// import Inactive from './pages/Inactive';
// import DeviceLifeCycle from './pages/system-configuration/DeviceLifeCycle';
// import DeviceTypes from './pages/system-configuration/DeviceTypes';
// import ConfigChangeEvents from './pages/ConfigChangeEvents';
// import DeveloperConsole from './pages/system-configuration/DeveloperConsole';
// import SitewiseView from './pages/SitewiseView';
// import Insights from './pages/Insights';
// import Reports from './pages/Reports';
// import CoPilotSummary from './pages/CoPilotSummary';
// import ISPDown1Card1 from './components/CopilotSummary/ISPDown1Card1';
// import ISPBad1 from './components/CopilotSummary/ISPBad1/ISPBad1Card1';
// import ISPGood1 from './components/CopilotSummary/ISPGood1/ISPGood1Card1';
// import ISPFlapping1 from './components/CopilotSummary/ISPFlapping1/ISPFlapping1';
// import SiteUp from './pages/SiteUp';
// import SiteDown from './pages/SiteDown';
// import SaasApplications from './pages/SaasApplication';
// import ViewAgents from './pages/ViewAgents';
// import AlertEmailConfig from './pages/AlertEmailConfig';
// import AlertIMConfig from './pages/AlertIMConfig';
// import SystemAlertEmailConfig from './pages/SystemAlertEmailConfig';
// import UtilizationConfig from './pages/UtilizationConfig';
// import ViewLinks from './pages/ViewLinks';
// import AddSingleISP from './pages/AddSingleISP';
// import EditSingleISP from './pages/EditSingleISP';
// import UploadMultipleISP from './pages/UploadMultipleISP';
// import DownAgentPage from './pages/DownAgentPage';
// import { useState } from 'react';
// import AppMonitorDashboardSiteView from './components/AppMonitorComponents/AppMonitorDashboardSiteView';
// import AppSitewiseView from './pages/AppSitewiseView';
// import IspDownPage from './pages/IspDownPage';
// import IspGoodPage from './pages/IspGoodPage';
// import EdgeDevice from './pages/EdgeDevice';
// import WanTable from './components/WifiComponents/WanTable';
// import AppTable from './components/WifiComponents/AppTable';
// import Wifi from './components/WifiComponents/Wifi';
// import WirelessTroubleShoot from './components/WifiComponents/WirelessTroubleShoot';
// import OverView from './components/VisibilityComponents/GlobalComponents/RelatedToGraph/OverView';
// import IndividualDevices from './components/configChangeEvents/Components/IndividualDevices';
// import SitewiseApplication from './components/SitewiseComponents/SitewiseApplication';
// import { EndpointsComponents } from './components/EndpointsComponents';
// import LogsTab from './components/SitewiseComponents/LogsTab';
// import { InventoryComponent } from './components/InventoryComponent';
// import { UnkownDevicesComponents } from './components/UnknownDevicesComponents';
// import InventoryTable from './components/SitewiseComponents/InventoryTable';
// import AvailabilityTab from './components/SitewiseComponents/AvailabilityTab';
// import AppMonitorDashboard from './components/AppMonitorComponents/AppMonitorDashboard';
// import { SummaryComponents } from './components/SummaryComponents';
// import ViewCloud from './components/CloudComponents/ViewCloud';
// import TotalCloudAssetsInfo from './components/CloudComponents/TotalCloudAssetsInfo';
// import TotalCloudAssets from './pages/TotalCloudAssets'; import Vendors from './pages/Vendors'
// import CCTVTable from './components/SitewiseComponents/CCTVTable';
// import DeXHealth from './pages/DeXHealth';
// import PoorLinks from './components/WifiComponents/PoorLinks';
// import FlappingLink from './components/WifiComponents/FlappingLink';
// import DownLinks from './components/WifiComponents/DownLinks';
// import OnpremServer from './pages/OnpremServer';
// import OnPremVM from './pages/OnPremVM';
// import BusinessUnit from './pages/BusinessUnit';
// import DexEnpoint from './pages/DexEnpoint';
// import BusinessLocationMapping from './components/Business Units/BusinesslocationMapping';
// import GroupManagement from './pages/GroupManagement';
// import ZoneManagement from './pages/ZoneManagement';
// import EdgeDeviceHealth from './pages/EdgeDeviceHealth';


// // ----------------------------------------------------------------------
// export default function Router() {
//   const [isShowingMore, setIsShowingMore] = useState(false);
//   return useRoutes([
//     {
//       path: '/',
//       element: <Login />,
//     },
//     {
//       path: '/dashboard',
//       element: <DashboardLayout />,
//       children: [
//         { path: 'dashboard', element: <Dashboard /> },
//         { path: 'network-health', element: <Network /> },
//         { path: 'locations', element: <Locations /> },
//         { path: 'ondemand', element: <OnDemand /> },
//         { path: 'dex-health/:identifier', element: <DeXHealth /> },
//         { path: 'dex-endpoints', element: <DexEnpoint /> },

//         {
//           path: 'infra-view',
//           element: <OrganisationInfra />,
//           children: [
//             { path: 'assets/internet', element: <InventoryTable /> },
//             { path: 'assets/network', element: <InventoryComponent /> },
//             { path: 'assets/unknown', element: <UnkownDevicesComponents /> },
//             { path: 'assets/cctv', element: <CCTVTable /> },
//             { path: '0', element: <OrganisationInfra /> },
//             { path: '1', element: <OverView /> },
//             { path: '2', element: <ConfigBackupTableComponent /> },
//             { path: '3', element: <IndividualDevices /> },
//             { path: '4', element: <SitewiseApplication /> },
//             { path: '5', element: <EndpointsComponents /> },
//             { path: '6', element: <LogsTab /> },
//             { path: '7', element: <ViewCloud /> }
//           ],
//         },
//         // { path : 'infra-view/7/toal-cloud-assets/:id',  element : <TotalCloudAssetsInfo/>},
//         { path: 'infra-view/7/cloud-assets/:id', element: <TotalCloudAssets /> },
//         { path: 'infra-view/7/Physical-Servers/:id', element: <OnpremServer /> },
//         { path: 'infra-view/7/Virtual-Machine/:id', element: <OnPremVM /> },

//         { path: 'site-wise/:locationUuid/:lelocationUuid?', element: <SitewiseView /> },
//         { path: 'site-wise', element: <SitewiseView /> },

//         { path: 'site-view/:lelocationUuid', element: <AppSitewiseView /> },
//         { path: 'isp-management/isp-down/:id', element: <IspDownPage /> },
//         { path: 'isp-management/isp-good/:id', element: <IspGoodPage /> },
//         { path: 'isp-management/isp-bad/:id', element: <ISPBad1 /> },
//         { path: 'isp-management/isp-flapping/:id/:status', element: <ISPFlapping1 /> },
//         { path: 'site-up', element: <SiteUp /> },
//         { path: 'site-down', element: <SiteDown /> },
//         // { path: 'add-multiple-links', element: <AddMultipleLinks /> },
//         // { path: 'manage-links', element: <ManageLink /> },
//         { path: 'insights', element: <Insights /> },
//         { path: 'reports', element: <Reports /> },
//         // { path: 'co-pilot-summary', element: <CoPilotSummary /> },
//         // {path: 'co-pilot-summary/internet', element: <WanTable />},
//         // {path: 'co-pilot-summary/wifi', element: <Wifi />},
//         // {path: 'co-pilot-summary/wirelesstroubleshoot', element: <WirelessTroubleShoot />},
//         // {path: 'co-pilot-summary/application', element: <AppTable />},
//         {
//           path: 'co-pilot-summary',
//           element: <CoPilotSummary />,
//           children: [
//             { path: 'internet', element: <WanTable /> },
//             { path: 'Poorlinks', element: <PoorLinks /> },
//             { path: 'Downlinks', element: <DownLinks /> },
//             { path: 'flaplinks', element: <FlappingLink /> },
//             { path: 'wifi', element: <Wifi /> },
//             { path: 'wirelesstroubleshoot', element: <WirelessTroubleShoot /> },
//             { path: 'application', element: <AppTable /> },
//           ],
//         },
//         { path: 'isp-management' },
//         { path: 'view-apps', element: <SaasApplications /> },
//         // {path:'itsm' , element: <InfoTechserviceManagement/>},
//         {
//           path: 'itsm',
//           element: <InfoTechserviceManagement />,
//           children: [
//             {
//               path: ':locationUuid/:serialNumber',
//               element: <InfoTechserviceManagement />
//             }
//           ]
//         },
//         { path: 'view-agents', element: <ViewAgents /> },
//         { path: 'alert-email-config', element: <AlertEmailConfig /> },
//         { path: 'alert-im-config', element: <AlertIMConfig /> },
//         { path: 'system-alert-email-config', element: <SystemAlertEmailConfig /> },
//         // Utilization
//         { path: 'utilization-Config', element: <UtilizationConfig /> },

//         { path: 'view-isp', element: <ViewLinks /> },
//         { path: 'add-single-isp/', element: <AddSingleISP /> },
//         { path: 'edit-single-isp/:id', element: <EditSingleISP /> },
//         { path: 'view-edge-device', element: <EdgeDevice /> },
//         { path: 'view-vendors', element: <Vendors /> },
//         {
//           path: 'business-units',
//           element: <BusinessUnit />,
//           children: [
//             {
//               path: 'buTable',
//               element: <BusinessUnit />
//             },
//             {
//               path: 'location-mapping',
//               element: <BusinessLocationMapping />
//             }
//           ]
//         },
//         { path: 'zones-management', element: <ZoneManagement /> },
//         // {path: '/dashboard/zones-location-map', element: <ZoneLocationMap/> },

//         {
//           path: 'upload-isp-csv', element: <UploadMultipleISP openTour={() => setIsOpen(true)}
//             toggleShowMore={() => setIsShowingMore((m) => !m)}
//             isShowingMore={isShowingMore} />
//         },
//         { path: 'down-dc-agent', element: <DownAgentPage /> },

//         {
//           path: 'health',
//           element: <Health />,
//           children: [
//             {
//               path: ':locationUuid/:serialNumber',
//               element: <Health />
//             }
//           ]
//         },
//         {
//           path: 'edge-device-health',
//           element: <EdgeDeviceHealth />,
//           children: [
//             {
//               path: ':deviceid',
//               element: <EdgeDeviceHealth />
//             }
//           ]
//         },
//         { path: 'network-device/inactive', element: <Inactive /> },
//         {
//           path: 'network-device',
//           element: <Inventory />,
//           children: [
//             { path: ':locationUuid', element: <Inventory /> }
//           ]
//         },
//         {
//           path: 'dashboard/device-up',
//           element: <DeviceUp />,
//           children: [
//             { path: ':locationUuid', element: <DeviceUp /> }
//           ]
//         },
//         {
//           path: 'dashboard/device-down',
//           element: <DeviceDown />,
//           children: [
//             { path: ':locationUuid', element: <DeviceDown /> }
//           ]
//         },
//         { path: 'global-map', element: <Global /> },
//         {
//           path: 'sitewise-map',
//           element: <Sitewise />,
//           children: [
//             { path: ':locationUuid', element: <OverView /> }
//           ]
//         },
//         { path: 'email-config', element: <EmailConfig /> },
//         { path: 'general', element: <General /> },
//         { path: 'ignore-rule', element: <IgnoreRule /> },

//         {
//           path: 'ISP-sitewise',
//           element: <Sidewise />,
//           children: [
//             { path: '', element: <SidewiseTotalLinks /> },
//             { path: 'sidewise-good', element: <SidewiseGood /> },
//             { path: 'sidewise-bad', element: <SidewiseBad /> },
//             { path: 'sidewise-down', element: <SidewiseDown /> },
//           ],
//         },

//         { path: 'endpoint', element: <Endpoint /> },
//         { path: 'inventory', element: <Inventory /> },
//         { path: 'ipam', element: <Ipam /> },
//         { path: 'summary-events', element: <Summary /> },
//         { path: 'grouped-summary', element: <GroupedSummary /> },
//         { path: 'devicewise-summary', element: <DevicewiseSummary /> },
//         { path: 'smtp-imap', element: <Smtp /> },
//         { path: 'sdwan', element: <Sdvan /> },
//         {
//           path: 'configuration',
//           element: <Configuration />,
//           children: [
//             {
//               path: ':customerName?/:locationName?/:deviceType?/:deviceIp?/:all?',
//               element: <S3BrowserComponent />,
//             },
//           ],
//         },
//         { path: 'members', element: <Members /> },
//         { path: 'roles', element: <Roles /> },
//         { path: 'dc-agent', element: <Dcagent /> },
//         { path: 'credential', element: <Credential /> },
//         { path: 'device-up-down', element: <Alerts /> },
//         { path: 'config-backup-events', element: <ConfigBackupEvents /> },
//         { path: 'config-change-events', element: <ConfigChangeEvents /> },

//         {
//           path: 'config-change-backup-table',
//           element: <ConfigChangeBackupTable />,
//           children: [
//             {
//               path: ':customerName?/:locationName?/:deviceType?/:deviceIp?/:all?',
//               element: <ConfigBackupTableComponent />,
//             },
//             {
//               path: 'backup-fail/:date',
//               // path: ':customerName?/:locationName?/:deviceType?/:deviceIp?/:all?',
//               element: <BackupFail />,
//             },
//             {
//               path: 'backup-success/:date',
//               element: <BackupSuccess />,
//             },
//           ],
//         },
//         { path: 'unknown-devices', element: <UnknownDevices /> },
//         { path: 'zones', element: <Zones /> },
//         {
//           path: 'isp-management',
//           element: <Overview />,
//           children: [
//             { path: 'isp-good', element: <ISPGood /> },
//             { path: 'isp-bad', element: <ISPBad /> },
//             { path: '', element: <ISPDown /> },
//           ],
//         },
//         { path: 'schedulers', element: <Schedulers /> },
//         { path: 'ISPConfig', element: null },
//         { path: 'settings', element: <Settings /> },
//         { path: 'group-management', element: <GroupManagement />, },
//         { path: 'isp-management/isp-good/1', element: <ISPGood1 /> },
//         { path: 'isp-management/isp-bad/1', element: <ISPBad1 /> },
//         { path: 'isp-management/isp-down/1', element: <ISPDown1 /> },


//         // { path : 'cloud/toal-cloud-assets/:id',  element : <TotalCloudAssetsInfo/>}
//         // { path : 'cloud/toal-cloud-assets/:id',  element : <TotalCloudAssets/>}
//       ],
//     },
//     {
//       path: '/system-configuration',
//       element: <DashboardLayout />,
//       children: [
//         { path: 'device-types', element: <DeviceTypes /> },
//         { path: 'developer-console', element: <DeveloperConsole /> },
//         { path: 'device-life-cycle', element: <DeviceLifeCycle /> },
//       ],
//     },
//     {
//       path: '/logout',
//       element: <LogoOnlyLayout />,
//     },
//     {
//       path: '/reset-password/:token',
//       element: <ResetPassword />,
//     },
//     {
//       path: 'forgot-password',
//       element: <ForgotPassword />,
//     },
//     { path: '*', element: <PageNotFound /> },
//   ]);
// }


import { useRoutes } from 'react-router-dom';

import { lazy, Suspense, useState } from 'react';

const DashboardLayout = lazy(() => import('./layouts/dashboard'));
const S3BrowserComponent = lazy(() => import('./components/CMDBBackups/S3BrowserComponent'));
const ISPBad = lazy(() => import('./components/ISPManagementTable/ISPManagementDashboard/ISPBad'));
const ISPDown = lazy(() => import('./components/ISPManagementTable/ISPManagementDashboard/ISPDown'));
const ISPDown1 = lazy(() => import('./components/ISPManagementTable/ISPManagementDashboard/ISPDown1/ISPDown1'));
const ISPGood = lazy(() => import('./components/ISPManagementTable/ISPManagementDashboard/ISPGood'));
const SidewiseBad = lazy(() => import('./components/SidewiseComponents/Components/SidewiseBad'));
const SidewiseDown = lazy(() => import('./components/SidewiseComponents/Components/SidewiseDown'));
const SidewiseGood = lazy(() => import('./components/SidewiseComponents/Components/SidewiseGood'));
const SidewiseTotalLinks = lazy(() => import('./components/SidewiseComponents/Components/SidewiseTotalLinks'));
const ConfigBackupTableComponent = lazy(() => import('./components/CMDBBackups/ConfigBackupTableComponent'));
const BackupFail = lazy(() => import('./components/SummaryComponents/Components/CardStatus/BackupFail/BackupFail'));
const BackupSuccess = lazy(() => import('./components/SummaryComponents/Components/CardStatus/BackupSuccess/BackupSuccess'));
const Alerts = lazy(() => import('./pages/Alerts'));
const ConfigBackupEvents = lazy(() => import('./pages/ConfigBackupEvents'));
const Configuration = lazy(() => import('./pages/Configuration'));
const Credential = lazy(() => import('./pages/Credential'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Dcagent = lazy(() => import('./pages/Dcagent'));
const EmailConfig = lazy(() => import('./pages/EmailConfig'));
const Endpoint = lazy(() => import('./pages/Endpoint'));
const Global = lazy(() => import('./pages/Global'));
const Inventory = lazy(() => import('./pages/Inventory'));
const Ipam = lazy(() => import('./pages/Ipam'));
const Locations = lazy(() => import('./pages/Locations'));
const Members = lazy(() => import('./pages/Members'));
const Network = lazy(() => import('./pages/Network'));
const OnDemand = lazy(() => import('./pages/OnDemand'));
const Overview = lazy(() => import('./pages/Overview'));
const Roles = lazy(() => import('./pages/Roles'));
const Schedulers = lazy(() => import('./pages/Schedulers'));
const Sdvan = lazy(() => import('./pages/Sdvan'));
const Sidewise = lazy(() => import('./pages/Sidewise'));
const Sitewise = lazy(() => import('./pages/Sitewise'));
const Smtp = lazy(() => import('./pages/Smtp'));
const Summary = lazy(() => import('./pages/Summary'));
const UnknownDevices = lazy(() => import('./pages/UnknownDevices'));
const Zones = lazy(() => import('./pages/Zones'));
const GroupedSummary = lazy(() => import('./pages/GroupedSummary'));
const DevicewiseSummary = lazy(() => import('./pages/DevicewiseSummary'));
const Health = lazy(() => import('./pages/Health'));
const OrganisationInfra = lazy(() => import('./pages/OrganisationInfra'));
const InfoTechserviceManagement = lazy(() => import('./pages/InfoTechserviceManagement'));

const PageNotFound = lazy(() => import('./components/PageNotFound'));
const ForgotPassword = lazy(() => import('./layouts/ForgotPassword'));
const Login = lazy(() => import('./layouts/Login'));
const LogoOnlyLayout = lazy(() => import('./layouts/LogoOnlyLayout'));
const ResetPassword = lazy(() => import('./layouts/ResetPassword'));
const Settings = lazy(() => import('./layouts/Settings'));
const DeviceDown = lazy(() => import('./pages/DeviceDown'));
const DeviceUp = lazy(() => import('./pages/DeviceUp'));
const ConfigChangeBackupTable = lazy(() => import('./pages/ConfigBackupsTable'));
const General = lazy(() => import('./pages/General'));
const IgnoreRule = lazy(() => import('./pages/IgnoreRule'));
const Inactive = lazy(() => import('./pages/Inactive'));
const DeviceLifeCycle = lazy(() => import('./pages/system-configuration/DeviceLifeCycle'));
const DeviceTypes = lazy(() => import('./pages/system-configuration/DeviceTypes'));
const ConfigChangeEvents = lazy(() => import('./pages/ConfigChangeEvents'));
const DeveloperConsole = lazy(() => import('./pages/system-configuration/DeveloperConsole'));
const SitewiseView = lazy(() => import('./pages/SitewiseView'));
const Insights = lazy(() => import('./pages/Insights'));
const Reports = lazy(() => import('./pages/Reports'));
const CoPilotSummary = lazy(() => import('./pages/CoPilotSummary'));
const ISPDown1Card1 = lazy(() => import('./components/CopilotSummary/ISPDown1Card1'));
const ISPBad1 = lazy(() => import('./components/CopilotSummary/ISPBad1/ISPBad1Card1'));
const ISPGood1 = lazy(() => import('./components/CopilotSummary/ISPGood1/ISPGood1Card1'));
const ISPFlapping1 = lazy(() => import('./components/CopilotSummary/ISPFlapping1/ISPFlapping1'));
const SiteUp = lazy(() => import('./pages/SiteUp'));
const SiteDown = lazy(() => import('./pages/SiteDown'));
const SaasApplications = lazy(() => import('./pages/SaasApplication'));
const ViewAgents = lazy(() => import('./pages/ViewAgents'));
const AlertEmailConfig = lazy(() => import('./pages/AlertEmailConfig'));
const AlertIMConfig = lazy(() => import('./pages/AlertIMConfig'));
const SystemAlertEmailConfig = lazy(() => import('./pages/SystemAlertEmailConfig'));
const UtilizationConfig = lazy(() => import('./pages/UtilizationConfig'));
const ViewLinks = lazy(() => import('./pages/ViewLinks'));
const AddSingleISP = lazy(() => import('./pages/AddSingleISP'));
const EditSingleISP = lazy(() => import('./pages/EditSingleISP'));
const UploadMultipleISP = lazy(() => import('./pages/UploadMultipleISP'));
const DownAgentPage = lazy(() => import('./pages/DownAgentPage'));
const AppMonitorDashboardSiteView = lazy(() => import('./components/AppMonitorComponents/AppMonitorDashboardSiteView'));
const AppSitewiseView = lazy(() => import('./pages/AppSitewiseView'));
const IspDownPage = lazy(() => import('./pages/IspDownPage'));
const IspGoodPage = lazy(() => import('./pages/IspGoodPage'));
const EdgeDevice = lazy(() => import('./pages/EdgeDevice'));
const WanTable = lazy(() => import('./components/WifiComponents/WanTable'));
const AppTable = lazy(() => import('./components/WifiComponents/AppTable'));
const Wifi = lazy(() => import('./components/WifiComponents/Wifi'));
const WirelessTroubleShoot = lazy(() => import('./components/WifiComponents/WirelessTroubleShoot'));
const OverView = lazy(() => import('./components/VisibilityComponents/GlobalComponents/RelatedToGraph/OverView'));
const IndividualDevices = lazy(() => import('./components/configChangeEvents/Components/IndividualDevices'));
const SitewiseApplication = lazy(() => import('./components/SitewiseComponents/SitewiseApplication'));
const EndpointsComponents = lazy(() => import('./components/EndpointsComponents'));
const LogsTab = lazy(() => import('./components/SitewiseComponents/LogsTab'));
const InventoryComponent = lazy(() => import('./components/InventoryComponent'));
const UnkownDevicesComponents = lazy(() => import('./components/UnknownDevicesComponents'));
const InventoryTable = lazy(() => import('./components/SitewiseComponents/InventoryTable'));
const AvailabilityTab = lazy(() => import('./components/SitewiseComponents/AvailabilityTab'));
const AppMonitorDashboard = lazy(() => import('./components/AppMonitorComponents/AppMonitorDashboard'));
const SummaryComponents = lazy(() => import('./components/SummaryComponents'));
const ViewCloud = lazy(() => import('./components/CloudComponents/ViewCloud'));
const TotalCloudAssetsInfo = lazy(() => import('./components/CloudComponents/TotalCloudAssetsInfo'));
const TotalCloudAssets = lazy(() => import('./pages/TotalCloudAssets'));
const Vendors = lazy(() => import('./pages/Vendors'));
const CCTVTable = lazy(() => import('./components/SitewiseComponents/CCTVTable'));
const DeXHealth = lazy(() => import('./pages/DeXHealth'));
const PoorLinks = lazy(() => import('./components/WifiComponents/PoorLinks'));
const FlappingLink = lazy(() => import('./components/WifiComponents/FlappingLink'));
const DownLinks = lazy(() => import('./components/WifiComponents/DownLinks'));
const OnpremServer = lazy(() => import('./pages/OnpremServer'));
const OnPremVM = lazy(() => import('./pages/OnPremVM'));
const BusinessUnit = lazy(() => import('./pages/BusinessUnit'));
const DexEnpoint = lazy(() => import('./pages/DexEnpoint'));
const BusinessLocationMapping = lazy(() => import('./components/Business Units/BusinesslocationMapping'));
const GroupManagement = lazy(() => import('./pages/GroupManagement'));
const ZoneManagement = lazy(() => import('./pages/ZoneManagement'));
const EdgeDeviceHealth = lazy(() => import('./pages/EdgeDeviceHealth'));

const LoadingFallback = () => {
  return null;
};



// const LoadingFallback = ({ message = 'Loading...' }) => (
//   <Box
//     sx={{
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'center',
//       alignItems: 'center',
//       minHeight: '80vh', 
//       width: '100%',
//       backgroundColor: '#f7f7f7', 
//       color: '#333', 
//       gap: 2,
//       p: 3,
//     }}
//   >
//     <Skeleton variant="rectangular" width="90%" height={700} sx={{ mb: 3, borderRadius: 2 }} />

   

//     {/* <Box sx={{ mt: 4, fontSize: '1.1rem', fontWeight: 500, color: '#666' }}>
//       {message}
//     </Box> */}
//   </Box>
// );


export default function Router() {
  const [isShowingMore, setIsShowingMore] = useState(false);
  return useRoutes([
    {
      path: '/',
      element: (
        <Suspense fallback={<LoadingFallback message="Authenticating..." />}>
          <Login />,
        </Suspense>
      )
    },
    {
      path: '/dashboard',
      element:
        (
          <Suspense fallback={<LoadingFallback />}>
            <DashboardLayout />
          </Suspense>
        ),
      children: [
        {
          path: 'dashboard',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Dashboard..." />}>
              <Dashboard />
            </Suspense>
          ),
        },
        {
          path: 'network-health',
          element: (
            <Suspense fallback={<LoadingFallback message="Fetching Network Health..." />}>
              <Network />
            </Suspense>
          ),
        },
        {
          path: 'locations',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Locations data..." />}>
              <Locations />
            </Suspense>
          ),
        },
        {
          path: 'ondemand',
          element: (
            <Suspense fallback={<LoadingFallback message="Preparing On-Demand view..." />}>
              <OnDemand />
            </Suspense>
          ),
        },
        {
          path: 'dex-health/:identifier',
          element: (
            <Suspense fallback={<LoadingFallback message="Analyzing DEX Health..." />}>
              <DeXHealth />
            </Suspense>
          ),
        },
        {
          path: 'dex-endpoints',
          element: (
            <Suspense fallback={<LoadingFallback message="Analyzing DEX Endpoints..." />}>
              <DexEnpoint />
            </Suspense>
          ),
        },

        {
          path: 'infra-view',
          element: (
            <Suspense fallback={<LoadingFallback message="Building Infrastructure View..." />}>
              <OrganisationInfra />
            </Suspense>
          ),
          children: [
            {
              path: 'assets/internet',
              element: (
                <Suspense fallback={<LoadingFallback message="Retrieving Internet Assets..." />}>
                  <InventoryTable />
                </Suspense>
              ),
            },
            {
              path: 'assets/network',
              element: (
                <Suspense fallback={<LoadingFallback message="Gathering Network Assets..." />}>
                  <InventoryComponent />
                </Suspense>
              ),
            },
            {
              path: 'assets/unknown',
              element: (
                <Suspense fallback={<LoadingFallback message="Scanning for Unknown Devices..." />}>
                  <UnkownDevicesComponents />
                </Suspense>
              ),
            },
            {
              path: 'assets/cctv',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading CCTV details..." />}>
                  <CCTVTable />
                </Suspense>
              ),
            },
            {
              path: '0',
              element: (
                <Suspense fallback={<LoadingFallback message="Initializing Infrastructure..." />}>
                  <OrganisationInfra />
                </Suspense>
              ),
            },
            {
              path: '1',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Overview..." />}>
                  <OverView />
                </Suspense>
              ),
            },
            {
              path: '2',
              element: (
                <Suspense fallback={<LoadingFallback message="Accessing Config Backups..." />}>
                  <ConfigBackupTableComponent />
                </Suspense>
              ),
            },
            {
              path: '3',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Individual Devices..." />}>
                  <IndividualDevices />
                </Suspense>
              ),
            },
            {
              path: '4',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Sitewise Applications..." />}>
                  <SitewiseApplication />
                </Suspense>
              ),
            },
            {
              path: '5',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Endpoint data..." />}>
                  <EndpointsComponents />
                </Suspense>
              ),
            },
            {
              path: '6',
              element: (
                <Suspense fallback={<LoadingFallback message="Retrieving Logs..." />}>
                  <LogsTab />
                </Suspense>
              ),
            },
            {
              path: '7',
              element: (
                <Suspense fallback={<LoadingFallback message="Fetching Cloud Overview..." />}>
                  <ViewCloud />
                </Suspense>
              ),
            },
          ],
        },
        {
          path: 'infra-view/7/Physical-Servers/:id',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading On-Prem Servers..." />}>
              <OnpremServer />
            </Suspense>
          ),
        },
        {
          path: 'infra-view/7/Virtual-Machine/:id',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Virtual Machines..." />}>
              <OnPremVM />
            </Suspense>
          ),
        },
        {
          path: 'site-wise/:locationUuid/:lelocationUuid?',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Site-Wise View..." />}>
              <SitewiseView />
            </Suspense>
          ),
        },
        {
          path: 'site-wise',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Site-Wise View..." />}>
              <SitewiseView />
            </Suspense>
          ),
        },
        {
          path: 'site-view/:lelocationUuid',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Application Site View..." />}>
              <AppSitewiseView />
            </Suspense>
          ),
        },
        {
          path: 'isp-management/isp-down/:id',
          element: (
            <Suspense fallback={<LoadingFallback message="Fetching Down ISPs..." />}>
              <IspDownPage />
            </Suspense>
          ),
        },
        {
          path: 'isp-management/isp-good/:id',
          element: (
            <Suspense fallback={<LoadingFallback message="Fetching Good ISPs..." />}>
              <IspGoodPage />
            </Suspense>
          ),
        },
        {
          path: 'isp-management/isp-bad/:id',
          element: (
            <Suspense fallback={<LoadingFallback message="Analyzing Bad ISPs..." />}>
              <ISPBad1 />
            </Suspense>
          ),
        },
        {
          path: 'isp-management/isp-flapping/:id/:status',
          element: (
            <Suspense fallback={<LoadingFallback message="Detecting Flapping ISPs..." />}>
              <ISPFlapping1 />
            </Suspense>
          ),
        },
        {
          path: 'site-up',
          element: (
            <Suspense fallback={<LoadingFallback message="Checking Site Up Status..." />}>
              <SiteUp />
            </Suspense>
          ),
        },
        {
          path: 'site-down',
          element: (
            <Suspense fallback={<LoadingFallback message="Retrieving Down Sites..." />}>
              <SiteDown />
            </Suspense>
          ),
        },
        {
          path: 'insights',
          element: (
            <Suspense fallback={<LoadingFallback message="Generating Insights..." />}>
              <Insights />
            </Suspense>
          ),
        },
        {
          path: 'reports',
          element: (
            <Suspense fallback={<LoadingFallback message="Compiling Reports..." />}>
              <Reports />
            </Suspense>
          ),
        },
        {
          path: 'co-pilot-summary',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Co-Pilot Summary..." />}>
              <CoPilotSummary />
            </Suspense>
          ),
          children: [
            {
              path: 'internet',
              element: (
                <Suspense fallback={<LoadingFallback message="Analyzing Internet Usage..." />}>
                  <WanTable />
                </Suspense>
              ),
            },
            {
              path: 'Poorlinks',
              element: (
                <Suspense fallback={<LoadingFallback message="Detecting Poor Links..." />}>
                  <PoorLinks />
                </Suspense>
              ),
            },
            {
              path: 'Downlinks',
              element: (
                <Suspense fallback={<LoadingFallback message="Checking Down Links..." />}>
                  <DownLinks />
                </Suspense>
              ),
            },
            {
              path: 'flaplinks',
              element: (
                <Suspense fallback={<LoadingFallback message="Monitoring Flapping Links..." />}>
                  <FlappingLink />
                </Suspense>
              ),
            },
            {
              path: 'wifi',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Wi-Fi Statistics..." />}>
                  <Wifi />
                </Suspense>
              ),
            },
            {
              path: 'wirelesstroubleshoot',
              element: (
                <Suspense fallback={<LoadingFallback message="Initiating Wireless Troubleshooting..." />}>
                  <WirelessTroubleShoot />
                </Suspense>
              ),
            },
            {
              path: 'application',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Application Data..." />}>
                  <AppTable />
                </Suspense>
              ),
            },
          ],
        },
        { path: 'isp-management' },
        {
          path: 'view-apps',
          element: (
            <Suspense fallback={<LoadingFallback message="Retrieving SaaS Applications..." />}>
              <SaasApplications />
            </Suspense>
          ),
        },
        {
          path: 'itsm',
          element: (
            <Suspense fallback={<LoadingFallback message="Accessing ITSM data..." />}>
              <InfoTechserviceManagement />
            </Suspense>
          ),
          children: [
            {
              path: ':locationUuid/:serialNumber',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading ITSM Details..." />}>
                  <InfoTechserviceManagement />
                </Suspense>
              ),
            },
          ],
        },
        {
          path: 'view-agents',
          element: (
            <Suspense fallback={<LoadingFallback message="Fetching Agent Information..." />}>
              <ViewAgents />
            </Suspense>
          ),
        },
        {
          path: 'alert-email-config',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Alert Email Configuration..." />}>
              <AlertEmailConfig />
            </Suspense>
          ),
        },
        {
          path: 'alert-im-config',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Alert IM Configuration..." />}>
              <AlertIMConfig />
            </Suspense>
          ),
        },
        {
          path: 'system-alert-email-config',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading System Alert Configuration..." />}>
              <SystemAlertEmailConfig />
            </Suspense>
          ),
        },
        {
          path: 'utilization-Config',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Utilization Configuration..." />}>
              <UtilizationConfig />
            </Suspense>
          ),
        },
        {
          path: 'view-isp',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading ISP Links..." />}>
              <ViewLinks />
            </Suspense>
          ),
        },
        {
          path: 'add-single-isp/',
          element: (
            <Suspense fallback={<LoadingFallback message="Preparing Add ISP form..." />}>
              <AddSingleISP />
            </Suspense>
          ),
        },
        {
          path: 'edit-single-isp/:id',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading ISP details for editing..." />}>
              <EditSingleISP />
            </Suspense>
          ),
        },
        {
          path: 'view-edge-device',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Edge Device data..." />}>
              <EdgeDevice />
            </Suspense>
          ),
        },
        {
          path: 'view-vendors',
          element: (
            <Suspense fallback={<LoadingFallback message="Fetching Vendor information..." />}>
              <Vendors />
            </Suspense>
          ),
        },
        {
          path: 'business-units',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Business Units..." />}>
              <BusinessUnit />
            </Suspense>
          ),
          children: [
            {
              path: 'buTable',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Business Unit Table..." />}>
                  <BusinessUnit />
                </Suspense>
              ),
            },
            {
              path: 'location-mapping',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Location Mappings..." />}>
                  <BusinessLocationMapping />
                </Suspense>
              ),
            },
          ],
        },
        {
          path: 'zones-management',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Zone Management..." />}>
              <ZoneManagement />
            </Suspense>
          ),
        },
        {
          path: 'upload-isp-csv',
          element: (
            <Suspense fallback={<LoadingFallback message="Preparing ISP Upload..." />}>
              <UploadMultipleISP
                openTour={() => setIsOpen(true)} // Assuming setIsOpen is defined somewhere or removed
                toggleShowMore={() => setIsShowingMore((m) => !m)}
                isShowingMore={isShowingMore}
              />
            </Suspense>
          ),
        },
        {
          path: 'down-dc-agent',
          element: (
            <Suspense fallback={<LoadingFallback message="Retrieving Down DC Agents..." />}>
              <DownAgentPage />
            </Suspense>
          ),
        },
        {
          path: 'health',
          element: (
            <Suspense fallback={<LoadingFallback message="Assessing Device Health..." />}>
              <Health />
            </Suspense>
          ),
          children: [
            {
              path: ':locationUuid/:serialNumber',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Health Details..." />}>
                  <Health />
                </Suspense>
              ),
            },
          ],
        },
        {
          path: 'edge-device-health',
          element: (
            <Suspense fallback={<LoadingFallback message="Evaluating Edge Device Health..." />}>
              <EdgeDeviceHealth />
            </Suspense>
          ),
          children: [
            {
              path: ':deviceid',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Edge Device Health Details..." />}>
                  <EdgeDeviceHealth />
                </Suspense>
              ),
            },
          ],
        },
        {
          path: 'network-device/inactive',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Inactive Devices..." />}>
              <Inactive />
            </Suspense>
          ),
        },
        {
          path: 'network-device',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Network Device Inventory..." />}>
              <Inventory />
            </Suspense>
          ),
          children: [
            {
              path: ':locationUuid',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Inventory for Location..." />}>
                  <Inventory />
                </Suspense>
              ),
            },
          ],
        },
        {
          path: 'dashboard/device-up',
          element: (
            <Suspense fallback={<LoadingFallback message="Fetching Up Devices..." />}>
              <DeviceUp />
            </Suspense>
          ),
          children: [
            {
              path: ':locationUuid',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Up Devices by Location..." />}>
                  <DeviceUp />
                </Suspense>
              ),
            },
          ],
        },
        {
          path: 'dashboard/device-down',
          element: (
            <Suspense fallback={<LoadingFallback message="Retrieving Down Devices..." />}>
              <DeviceDown />
            </Suspense>
          ),
          children: [
            {
              path: ':locationUuid',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Down Devices by Location..." />}>
                  <DeviceDown />
                </Suspense>
              ),
            },
          ],
        },
        {
          path: 'global-map',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Global Map..." />}>
              <Global />
            </Suspense>
          ),
        },
        {
          path: 'sitewise-map',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Site-Wise Map..." />}>
              <Sitewise />
            </Suspense>
          ),
          children: [
            {
              path: ':locationUuid',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Map Overview..." />}>
                  <OverView />
                </Suspense>
              ),
            },
          ],
        },
        {
          path: 'email-config',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Email Configuration..." />}>
              <EmailConfig />
            </Suspense>
          ),
        },
        {
          path: 'general',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading General Settings..." />}>
              <General />
            </Suspense>
          ),
        },
        {
          path: 'ignore-rule',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Ignore Rules..." />}>
              <IgnoreRule />
            </Suspense>
          ),
        },
        {
          path: 'ISP-sitewise',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading ISP Site-Wise Data..." />}>
              <Sidewise />
            </Suspense>
          ),
          children: [
            {
              path: '',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Total ISP Links..." />}>
                  <SidewiseTotalLinks />
                </Suspense>
              ),
            },
            {
              path: 'sidewise-good',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Good ISP Links..." />}>
                  <SidewiseGood />
                </Suspense>
              ),
            },
            {
              path: 'sidewise-bad',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Bad ISP Links..." />}>
                  <SidewiseBad />
                </Suspense>
              ),
            },
            {
              path: 'sidewise-down',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Down ISP Links..." />}>
                  <SidewiseDown />
                </Suspense>
              ),
            },
          ],
        },
        {
          path: 'endpoint',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Endpoints..." />}>
              <Endpoint />
            </Suspense>
          ),
        },
        {
          path: 'inventory',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Inventory..." />}>
              <Inventory />
            </Suspense>
          ),
        },
        {
          path: 'ipam',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading IP Address Management..." />}>
              <Ipam />
            </Suspense>
          ),
        },
        {
          path: 'summary-events',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Summary Events..." />}>
              <Summary />
            </Suspense>
          ),
        },
        {
          path: 'grouped-summary',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Grouped Summary..." />}>
              <GroupedSummary />
            </Suspense>
          ),
        },
        {
          path: 'devicewise-summary',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Device-Wise Summary..." />}>
              <DevicewiseSummary />
            </Suspense>
          ),
        },
        {
          path: 'smtp-imap',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading SMTP/IMAP Settings..." />}>
              <Smtp />
            </Suspense>
          ),
        },
        {
          path: 'sdwan',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading SD-WAN Configuration..." />}>
              <Sdvan />
            </Suspense>
          ),
        },
        {
          path: 'configuration',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Configuration..." />}>
              <Configuration />
            </Suspense>
          ),
          children: [
            {
              path: ':customerName?/:locationName?/:deviceType?/:deviceIp?/:all?',
              element: (
                <Suspense fallback={<LoadingFallback message="Accessing S3 Browser..." />}>
                  <S3BrowserComponent />
                </Suspense>
              ),
            },
          ],
        },
        {
          path: 'members',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Members List..." />}>
              <Members />
            </Suspense>
          ),
        },
        {
          path: 'roles',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Roles..." />}>
              <Roles />
            </Suspense>
          ),
        },
        {
          path: 'dc-agent',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading DC Agent Information..." />}>
              <Dcagent />
            </Suspense>
          ),
        },
        {
          path: 'credential',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Credentials..." />}>
              <Credential />
            </Suspense>
          ),
        },
        {
          path: 'device-up-down',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Device Status Alerts..." />}>
              <Alerts />
            </Suspense>
          ),
        },
        {
          path: 'config-backup-events',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Config Backup Events..." />}>
              <ConfigBackupEvents />
            </Suspense>
          ),
        },
        {
          path: 'config-change-events',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Config Change Events..." />}>
              <ConfigChangeEvents />
            </Suspense>
          ),
        },
        {
          path: 'config-change-backup-table',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Config Change Backup Table..." />}>
              <ConfigChangeBackupTable />
            </Suspense>
          ),
          children: [
            {
              path: ':customerName?/:locationName?/:deviceType?/:deviceIp?/:all?',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Configuration Backups..." />}>
                  <ConfigBackupTableComponent />
                </Suspense>
              ),
            },
            {
              path: 'backup-fail/:date',
              element: (
                <Suspense fallback={<LoadingFallback message="Fetching Backup Failures..." />}>
                  <BackupFail />
                </Suspense>
              ),
            },
            {
              path: 'backup-success/:date',
              element: (
                <Suspense fallback={<LoadingFallback message="Fetching Successful Backups..." />}>
                  <BackupSuccess />
                </Suspense>
              ),
            },
          ],
        },
        {
          path: 'unknown-devices',
          element: (
            <Suspense fallback={<LoadingFallback message="Searching for Unknown Devices..." />}>
              <UnknownDevices />
            </Suspense>
          ),
        },
        {
          path: 'zones',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Zones..." />}>
              <Zones />
            </Suspense>
          ),
        },
        {
          path: 'isp-management',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading ISP Management Overview..." />}>
              <Overview />
            </Suspense>
          ),
          children: [
            {
              path: 'isp-good',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Good ISPs..." />}>
                  <ISPGood />
                </Suspense>
              ),
            },
            {
              path: 'isp-bad',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Bad ISPs..." />}>
                  <ISPBad />
                </Suspense>
              ),
            },
            {
              path: '',
              element: (
                <Suspense fallback={<LoadingFallback message="Loading Down ISPs..." />}>
                  <ISPDown />
                </Suspense>
              ),
            },
          ],
        },
        {
          path: 'schedulers',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Schedulers..." />}>
              <Schedulers />
            </Suspense>
          ),
        },
        { path: 'ISPConfig', element: null },
        {
          path: 'settings',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Settings..." />}>
              <Settings />
            </Suspense>
          ),
        },
        {
          path: 'group-management',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Group Management..." />}>
              <GroupManagement />
            </Suspense>
          ),
        },
        {
          path: 'isp-management/isp-good/1',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading ISP Good Details..." />}>
              <ISPGood1 />
            </Suspense>
          ),
        },
        {
          path: 'isp-management/isp-bad/1',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading ISP Bad Details..." />}>
              <ISPBad1 />
            </Suspense>
          ),
        },
        {
          path: 'isp-management/isp-down/1',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading ISP Down Details..." />}>
              <ISPDown1 />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: '/system-configuration',
      element: <DashboardLayout />,
      children: [
        {
          path: 'device-types',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Device Types..." />}>
              <DeviceTypes />
            </Suspense>
          ),
        },
        {
          path: 'developer-console',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Developer Console..." />}>
              <DeveloperConsole />
            </Suspense>
          ),
        },
        {
          path: 'device-life-cycle',
          element: (
            <Suspense fallback={<LoadingFallback message="Loading Device Life Cycle..." />}>
              <DeviceLifeCycle />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: '/logout',
      element: (
        <Suspense fallback={<LoadingFallback message="Logging out..." />}>
          <LogoOnlyLayout />
        </Suspense>
      ),
    },
    {
      path: '/reset-password/:token',
      element: (
        <Suspense fallback={<LoadingFallback message="Loading Reset Password..." />}>
          <ResetPassword />
        </Suspense>
      ),
    },
    {
      path: 'forgot-password',
      element: (
        <Suspense fallback={<LoadingFallback message="Loading Forgot Password page..." />}>
          <ForgotPassword />
        </Suspense>
      ),
    },
    {
      path: '*',
      element: (
        <Suspense fallback={<LoadingFallback message="Navigating to Page Not Found..." />}>
          <PageNotFound />
        </Suspense>
      ),
    },
  ]);
}